import * as THREE from 'three';

let isLearningActive = true;
let currentCardIndex = 0;
let uiOverlay, cardContent, timerElement;
let folderBox;
let finishCallback = null; // Храним колбэк здесь

const cardTextures = [
    './assets/images/Anna.png',
    './assets/images/Margarita.png',
    './assets/images/Dmitriy.png',

];

// Добавили параметр onFinish
export async function learningStage(scene, camera, renderer, folderObj, onFinish) {
    folderBox = folderObj;
    finishCallback = onFinish; // Запоминаем функцию завершения

    // Инициализируем элементы
    createTimer();
    createCardUI();

    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    const onClick = (e) => {
        if (!isLearningActive) return;
        
        // Если оверлей уже открыт, не пускаем луч в 3D
        if (uiOverlay && uiOverlay.style.display === 'flex') return;

        mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;

        raycaster.setFromCamera(mouse, camera);
        const intersects = raycaster.intersectObject(folderBox);

        if (intersects.length > 0) {
            // Скрываем лейбл при первом же клике на папку (через колбэк)
            if (finishCallback) finishCallback();
            showCardSystem();
        }
    };

    window.addEventListener('click', onClick);
}

function createTimer() {
    timerElement = document.createElement('div');
    timerElement.id = 'learning-timer';
    timerElement.style.cssText = `
        position: fixed; 
        top: 20px; 
        right: 20px; 
        color: white;
        background: rgba(0,0,0,0.8); 
        padding: 15px;
        font-family: sans-serif; 
        font-size: 18px; 
        border-radius: 10px; 
        z-index: 2000; 
        pointer-events: none;
        border: 1px solid rgba(255,255,255,0.2);
    `;
    document.body.appendChild(timerElement);

    let timeLeft = 90; // Поставил 30 секунд для теста, верни 3 если нужно быстро
    const interval = setInterval(() => {
        if (!isLearningActive) {
            clearInterval(interval);
            return;
        }
        const mins = Math.floor(timeLeft / 60);
        const secs = timeLeft % 60;
        timerElement.innerText = `Через ${mins}:${secs < 10 ? '0' : ''}${secs} планируется звонок в LFU BOOM (изучите персонажей по подсказке)`;
        
        if (timeLeft <= 0) {
            clearInterval(interval);
            finishLearning();
        }
        timeLeft--;
    }, 1000);
}

function createCardUI() {
    uiOverlay = document.createElement('div');
    uiOverlay.id = 'learning-ui-overlay';
    uiOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.85);
        display: none;
        justify-content: center;
        align-items: center;
        z-index: 5000;
        backdrop-filter: blur(8px);
    `;

    cardContent = document.createElement('div');
    cardContent.style.cssText = `
        width: min(550px, 90vw);
        height: min(700px, 80vh);
        background: #fff;
        box-shadow: 0 0 50px rgba(0,0,0,0.5);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    `;

    uiOverlay.appendChild(cardContent);
    document.body.appendChild(uiOverlay);

    uiOverlay.addEventListener('click', (e) => {
        e.stopPropagation();
        nextCard();
    });
}

function showCardSystem() {
    uiOverlay.style.display = 'flex';
    currentCardIndex = 0;
    updateCardUI();
}

function nextCard() {
    currentCardIndex++;
    if (currentCardIndex >= cardTextures.length) {
        uiOverlay.style.display = 'none';
        return;
    }
    updateCardUI();
}

function updateCardUI() {
    cardContent.style.backgroundImage = `url('${cardTextures[currentCardIndex]}')`;
}

function finishLearning() {
    isLearningActive = false;
    if (timerElement) timerElement.remove();
    if (uiOverlay) uiOverlay.remove();
    
    // Вызываем колбэк завершения, чтобы скрыть лейбл в основной сцене
    if (finishCallback) finishCallback();

    // Дополнительный поиск элемента по ID на случай, если THREE залагал
    const labelEl = document.getElementById('folder-instruction-label');
    if (labelEl) labelEl.style.display = 'none';
}

export function isLearning() {
    return isLearningActive;
}